import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: IUserDetailState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const userSlice = createSlice({
  name: "user",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceUser: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addUser: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },

    updateUser: (state, action) => {
    const { data } = action.payload;

    if (state.data) {
    const index = state.data.findIndex(
      item => item.id === data.id
    );

    if (index !== -1) {
      state.data[index] = data;
    }
    }

    state.Details = data;
    },

    deleteUser: (state, action) => {
      const userToRemove: IUserDetail = action.payload.data;
      const newUserData =
        state.data &&
        state.data.filter((user: IUserDetail) => {
          return user.id !== userToRemove.id;
        });
      state.data = newUserData;
      state.totalCount = state.totalCount - 1;
    },
    setUserDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
